import React from 'react';

/**
 *
 * icons icon-private-inquiries-warshatna, icon icon-inquiries-warshatna
 */

const Stats = ({ title, sections = [] }) => {
  return (
    <div className='container mb-5'>
      <h2>{title}</h2>
      <div
        className='statics--bar lazyload'
        data-bg='/assets/images/gold-pattern2.png'
      >
        <div className='container'>
          <div className='row py-5'>
            {/* Products  */}
            {sections.map((data, index) => {
              return (
                <div className='item d-flex col-4 mb-5'>
                  {/* {data?.icon === 'pri'} */}
                  <div className={data?.icon} ></div>
                  <div className='info'>
                    <span className='title'>{data?.title} </span>
                    <div className='numbers row'>
                      <div className='col-6'>
                        <a  title='Item' className='item'>
                          <span className='number'>{data?.item?.count}</span>
                          <span className='text'>{data?.item?.title}</span>
                        </a>
                      </div> 
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stats;
